import IconFilters from '@assets/icons/filters.svg?react';
import { IconButton } from '@mui/material';
import {
	type GridColumnHeaderParams,
	useGridApiContext,
} from '@mui/x-data-grid-premium';
import type { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import customColors from '../../../utils/customColors';
import type { CustomGridApi } from './types';

const HeaderFilterIcon = ({
	field,
	counter,
	onClick,
}: {
	field: string;
	counter?: number;
	onClick?: (
		params: GridColumnHeaderParams,
		event: React.MouseEvent<HTMLButtonElement>,
	) => void;
}) => {
	const { t } = useTranslation();
	const apiRef = useGridApiContext() as MutableRefObject<CustomGridApi>;
	const currentFilters = apiRef.current.state.filter.filterModel.items;
	const hasFilter = currentFilters.some((filter) => filter.field === field);

	return (
		(counter || hasFilter) && (
			<IconButton
				title={t('global.openColumnFilter')}
				aria-label={t('global.openColumnFilter')}
				onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
					event.preventDefault();
					event.stopPropagation();
					apiRef.current.setFilterMenuState({
						anchorElement: event.currentTarget,
						colName: field,
					});
				}}
				sx={{
					'& path': {
						stroke: customColors.blue,
					},
				}}
			>
				<IconFilters />
			</IconButton>
		)
	);
};
export default HeaderFilterIcon;
